import { Component } from '@angular/core';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import 'rxjs/Rx';
import { AlertService } from '../../../../sharedcomponents/commonservice/alert.service';
import { AppSettings } from '../../../../sharedcomponents/_common/constants/app.constants';
import { UserService } from '../../../../_services/userservice/user.service';


export class CustomModalContext extends BSModalContext {
  public modalData: any;
}

@Component({
  selector: 'app-link-user',
  templateUrl: './link-user.component.html',
  styleUrls: ['./link-user.component.css'],
  providers: [UserService, AppSettings, AlertService]
})
export class LinkUserComponent implements ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  model: any = {};
  //user: User;
  loading = false;
  public wrongAnswer: boolean;

  constructor(public dialog: DialogRef<CustomModalContext>, public modal: Modal) {
    this.wrongAnswer = true;
    this.context = dialog.context;
  }

  linkUserOkClick() {
    this.wrongAnswer = false;
    this.context.modalData.status = 'yes';
    this.dialog.close();
    // this.openVerificationPopup();
  }
  linkUserCancelClick() {
    this.wrongAnswer = false;
    this.context.modalData.status = 'no';
    this.dialog.close();
  }

  // openVerificationPopup() {
  //   this.dialog.close();
  //   let user = this.context.modalData.user;
  //   this.openLoyaltyCardVerificationStep2(user);
  // }

  // openLoyaltyCardVerificationStep2(loyaltyCardModel: any) {
  //   return this.modal.open(loyaltyCardverificationComponent, overlayConfigFactory({ loyaltyCardModel }, BSModalContext));
  // }

  // openMobileVerificationPopup() {
  //   this.dialog.close();
  //   let user = this.context.modalData.user;
  //   return this.modal.open(VerifyMobileComponent, overlayConfigFactory({ user }, BSModalContext));
  // }
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/RegistrationPopup/link-user/link-user.component.ts